export default "__VITE_ASSET__Be4b5AFO__"